<script>
export default {
  name: "PassHelperComponent",
  render() {
    return this.$scopedSlots.default(this.$attrs);
  },
};
</script>
